import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Crown, Medal } from "@phosphor-icons/react";

const STYLE = {
  gold: "bg-amber-400/20 text-amber-600",
  silver: "bg-slate-400/20 text-slate-500",
  bronze: "bg-orange-700/15 text-orange-700",
};

export function LoyaltyBadge() {
  const { data } = useQuery({ queryKey: ["loyalty"], queryFn: async () => (await api.get("/loyalty/me")).data });
  if (!data) return null;
  return (
    <span data-testid="loyalty-badge" className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${STYLE[data.tier]}`}>
      {data.tier === "gold" ? <Crown size={13} weight="fill" /> : <Medal size={13} weight="fill" />}
      <span className="capitalize">{data.tier}</span>
      {data.perks?.free_delivery && <span className="font-normal opacity-80">· no surge · free delivery</span>}
      {data.next && <span className="font-normal opacity-70">· {data.next.need} more to {data.next.tier}</span>}
    </span>
  );
}
